__turbopack_context__.v({
  "danger": "mpH7Va_danger",
  "label": "mpH7Va_label",
  "neutral": "mpH7Va_neutral",
  "paused": "mpH7Va_paused",
  "success": "mpH7Va_success",
  "ticker": "mpH7Va_ticker",
});
